import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "hero-carousel" }
const _hoisted_2 = {
  key: 0,
  class: "hero-carousel__slider"
}
const _hoisted_3 = { class: "swiper hero-carousel-slider" }
const _hoisted_4 = { class: "swiper-wrapper" }
const _hoisted_5 = { class: "swiper-slide" }
const _hoisted_6 = {
  key: 1,
  class: "hero-carousel__control"
}
const _hoisted_7 = { class: "hero-carousel__control-buttons" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_hero_carousel_slide = _resolveComponent("hero-carousel-slide")!
  const _component_hero_carousel_play_pause = _resolveComponent("hero-carousel-play-pause")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    ($props.slides.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.slides, (slide, i) => {
                return (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  (_openBlock(), _createBlock(_component_hero_carousel_slide, {
                    slide: slide,
                    key: i
                  }, null, 8, ["slide"]))
                ]))
              }), 256))
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    ($props.slides.length > 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("span", _hoisted_7, [
            _createVNode(_component_hero_carousel_play_pause, {
              "is-pause": $setup.playPauseState,
              onClick: $setup.togglePlayPause
            }, null, 8, ["is-pause", "onClick"]),
            _cache[0] || (_cache[0] = _createElementVNode("div", { class: "hero-carousel-pagination" }, null, -1))
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}